import { useState } from "react";
import { useSelector } from "react-redux";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "../../../../ui/dialog";
import { Button } from "../../../../ui/button";
import { Input } from "../../../../ui/input";
import { Textarea } from "../../../../ui/textarea";
import { postQuery } from "../../../../../apiManager/shared/Query";
import { FaQuestion } from "react-icons/fa6";

export function QueryDialog({ job, onSend }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const userId = useSelector(state => state.auth.userInfo?.user?.id);

  const handleSend = async () => {
    if (!title.trim() || !description.trim()) return;

    setLoading(true);
    setError("");
    
    try {
      const res = await postQuery(job._id, userId, title, description);
      if (res.error) {
        setError(res.error);
        return;
      }
      alert('Your query has been sent successfully');
      setTitle("");
      setDescription("");
      setOpen(false);
      
      // Call the onSend callback if provided
      if (onSend) {
        onSend({ title, description });
      }
    } catch (error) {
      setError(error.error || "Server error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenChange = (isOpen) => {
    setOpen(isOpen);
    // Reset states when dialog closes
    if (!isOpen) {
      setTitle("");
      setDescription("");
      setError("");
    }
  };

  return (
    <>
      {/* Trigger Button */}
      <Button 
      size="icon"
      variant="outline"
        onClick={() => setOpen(true)}
        className="absolute top-4 right-4"
      >
        <FaQuestion />
      </Button>

      {/* Dialog */}
      <Dialog open={open} onOpenChange={handleOpenChange}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Ask a Question</DialogTitle>
            <DialogDescription>
              Have a question about this job? Our support team will help you.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="query-title" className="text-sm font-medium">
                Title
              </label>
              <Input
                id="query-title"
                placeholder="Enter a brief title for your question..."
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                disabled={loading}
                className="w-full"
              />
            </div>
            
            <div className="space-y-2">
              <label htmlFor="query-description" className="text-sm font-medium">
                Descriptions
              </label>
              <Textarea
                id="query-description"
                placeholder="Provide detailed information about your question..."
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                disabled={loading}
                className="w-full h-32"
              />
            </div>
            
            {error && (
              <p className="text-red-500 text-sm">{error}</p>
            )}
          </div>
          <DialogFooter>
            <Button 
              variant="outline" 
              onClick={() => handleOpenChange(false)}
              disabled={loading}
            >
              Cancel
            </Button>
            <Button 
              onClick={handleSend} 
              className="bg-black hover:bg-gray-800 text-white"
              disabled={loading || !title.trim() || !description.trim()}
            >
              {loading ? "Sending..." : "Send Query"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}